import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { RegularRate, overtimeFactor, overtimeRate } from 'app/models/Placement/PlacementMods';
import { OvertimeFactor } from '../../PayRate/PayFactor/OvertimeFactor';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from './BillOrientation';

export const getCalculatedAmount = (getValues, factor) => {
  //@Team @Shyam Moorthy - remove unused variables
  const value = getValues(factor) ? parseFloat(getValues(RegularRate)) + parseFloat(getValues(factor)) : '0.00';
  const helperDiv = (
    <>
      <span>
        (Amount = $
        {getValues(factor) ? (parseFloat(getValues(RegularRate)) + parseFloat(getValues(factor))).toFixed(2) : '0.00'})
      </span>
    </>
  );

  return helperDiv;
};

export const BillOvertime = ({ classes, isModEdit }: { classes: any; isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const overtimeRateValue = useWatch<any>({ name: overtimeRate });
  const regularRateValue = useWatch<string>({ name: RegularRate });

  return (
    <Grid item className={classes.flex}>
      <Controller
        name={overtimeRate}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={overtimeRateValue}
            className={classes.billFactorTextfields}
            InputLabelProps={{
              shrink: getValues(overtimeRate),
            }}
            variant="filled"
            label={`${t(`placement.placementMods.${overtimeRate}`)}`}
            helperText={regularRateValue ? getCalculatedAmount(getValues, overtimeRate) : getInvalidAmount()}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 6, decimalLength: 2 })) {
                onChange(e.target.value);
                setValue(overtimeRate, e.target.value);
                setValue(overtimeFactor, '');
              }
            }}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>{overtimeRateValue && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>
              ),
              sx: { fontSize: '14px' },
            }}
            {...rest}
          />
        )}
      />
      <div className={classes.middleText}>{'OR'}</div>
      <OvertimeFactor classes={classes} currentMod={'BillRate'} isModEdit={isModEdit} />
    </Grid>
  );
};
